import { AppProviders } from './providers'

export default function App() {
  return <AppProviders />
}
